


import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderLinesListStyles } from "@insite/content-library/Components/OrderLinesList";
import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

orderLinesListStyles.productInfoDescriptionGridItem
= mergeToNew(orderLinesListStyles.productInfoDescriptionGridItem
    , {
    css: css`
        a {
            span{
                color: ${getColor("text.main")};
                font-size:${TYPOGRAPHY.size.larger};
                :hover {
                    text-decoration:underline;
                }
            }
            display:block;
        }
    `,
});

orderLinesListStyles.orderLineCardAddToListButton
= mergeToNew(orderLinesListStyles.orderLineCardAddToListButton
    , {
    css: css`
        border-radius:0;
    `,
});

orderLinesListStyles.addToListClickable
= mergeToNew(orderLinesListStyles.addToListClickable
    , {
    css: css`
        border-radius:0;
    `,
});
orderLinesListStyles.orderLineCardActionsWide
= mergeToNew(orderLinesListStyles.orderLineCardActionsWide
    , {
    css: css`
    button {
        background: ${getColor("primary.contrast")};
    }
    `,
});




